/**
 * The longest message one person can send in one go: a customer in chat, by
 * email or on the contact form, and the team answering them. One number, used
 * by the browser and the server alike.
 *
 * Generous on purpose. VO1SVD (2026-10-28): a customer's two complaint
 * letters, about 5,000 characters each, were cut at 4,000 by the chat server,
 * so the team never read how either one ended, and nobody knew. A message is
 * never cut short silently: over this, the sender is told to split it.
 */
export const MESSAGE_MAX_CHARS = 20000;

/** What the sender reads when a message is over the limit. */
export const MESSAGE_TOO_LONG =
  `That message is longer than ${MESSAGE_MAX_CHARS.toLocaleString('en-US')} characters. Please send it in two parts so nothing gets left out.`;
